import { isObject } from 'lodash-es';
import { isApp } from './index';
import { strPadLeft } from '../index';
import useClipboard from 'vue-clipboard3';
import { showToast } from 'vant';

const { toClipboard } = useClipboard();

// import UAParser from 'ua-parser-js'
// import $ from 'jquery';

export const copyText = async text => {
  try {
    await toClipboard(text);
    showToast('复制成功');
  } catch (e) {
    showToast('复制失败');
  }
};

export const safeToFixed = (input, digits) => {
  const number = Number(input);
  if (isNaN(number)) {
    return 0;
  }
  return number.toFixed(digits);
};

// 去除所有空格
export const removeSpaces = value => {
  return value.replace(/\s+/g, '');
};

export function deepMerge<T = any>(src: any = {}, target: any = {}): T {
  let key: string;
  for (key in target) {
    src[key] = isObject(src[key]) && src[key] !== null ? deepMerge(src[key], target[key]) : (src[key] = target[key]);
  }
  return src;
}

// 字符串中间...省略显示
export const getEllipsisText = (text: string, start: number = 3, end: number = 4) => {
  if (!text) return text;
  return `${text.slice(0, start)}...${text.slice(-end)}`;
};

// 校验密码 1：纯数字 2：数字+字母 3：数字+大小字母 4：数字+大小字母 +特殊字符 5: 内容随意,只限制6-16位长度
export const checkPwd = (str, level, min = 1, max = 6) => {
  let reg = {
    0: new RegExp(`^\\d{${min},${max}}$`),
    1: /^(?=.*\d)[0-9]{6,16}$/,
    2: /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{6,16}$/,
    3: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{6,16}$/,
    4: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@//^#\-%/.+:;=*])[a-zA-Z0-9~@//^#\-%/.+:;=*]{6,16}$/,
    5: /^.{6,16}$/,
  };
  return reg[level] && reg[level].test(str);
};

// 校验密码等级
export const checkPwdLevel = str => {
  let level = '1';
  let reg = {
    1: /^(?=.*\d)[0-9]{6,16}$/,
    2: /^(?=.*\d)(?=.*[a-zA-Z])[a-zA-Z0-9]{6,16}$/,
    3: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{6,16}$/,
    4: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@//^#\-%/.+:;=*])[a-zA-Z0-9~@//^#\-%/.+:;=*]{6,16}$/,
    5: /^.{6,16}$/,
  };
  for (let key in reg) {
    reg[key].test(str) && (level = key);
  }
  return level;
};

// 校验是否含有空格
export const checkBlankReg = (s: string) => {
  let reg = new RegExp(/^[^\s]*$/);
  return reg.test(s);
};

// 验证邮箱
export const checkEmailReg = (s: string) => {
  let reg = new RegExp(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/);
  return reg.test(s);
};

// 验证手机号码
export const checkPhoneReg = (s: string) => {
  let reg = new RegExp(/^[0-9]{6,12}$/);
  return reg.test(s);
};

export const maskEmail = (email: string) => {
  return email.replace(/(.{1,4}).*@/, '$1***@');
};

export const uuid = (len, radix) => {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const uuid: any[] = [];
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (let i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    /* eslint-disable */
    var r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = '4';

    // Fill in random data. At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (let i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
    /* eslint-enable */
  }
  return uuid.join('');
};

// 保存图片方法 data是链接 或者 canvasDom元素
export const saveImg = (data: any, name, { success, error }) => {
  if ((typeof data).toLowerCase() === 'string') {
    if (data.substring(0, 10) !== 'data:image') {
      let url = data;
      let ext = url.slice(url.lastIndexOf('.') + 1).toLowerCase();
      if (ext === 'jpg' || ext === 'gif' || ext === 'jpeg' || ext === 'bmp' || ext === 'png') {
        url2base64(url)
          .then(base64 => {
            startDownload(base64);
          })
          .catch(() => {
            error && error('保存图片失败');
          });
      } else {
        error && error('保存图片失败');
      }
    } else {
      startDownload(data);
    }
  } else {
    let base64 = data.toDataURL('image/png');
    startDownload(base64);
  }

  function base64url2blob(base64) {
    let parts = base64.split(';base64,');
    let contentType = parts[0].split(':')[1];
    let raw = window.atob(parts[1]);
    let rawLength = raw.length;
    let uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; i++) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }
  function url2base64(url) {
    return new Promise(function (resolve, reject) {
      let img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = url;
      img.onload = function () {
        let canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        let ctx: any = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height);
        let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase();
        let base64 = canvas.toDataURL('image/' + ext);
        resolve(base64);
      };
      img.onerror = function (err) {
        reject(err);
      };
    });
  }
  function startDownload(base64) {
    if (isApp()) {
    } else {
      let blob = base64url2blob(base64);
      let a = document.createElement('a');
      a.download = name;
      a.href = URL.createObjectURL(blob);
      a.click();
      success && success('保存图片成功');
    }
  }
};

// export const loadJSONP = (url, callback) => {
//   $.ajax({
//     url: url,
//     dataType: 'jsonp',
//     type: 'get',
//     timeout: 6000,
//     complete: (req, status) => {
//       if (req.status === 200 || req.status === 417 || req.status === 416) {
//         callback('success');
//       } else {
//         callback('error');
//       }
//     }
//   });
// };

/**
 * 动态加载js
 */
export function loadJs(src: string, text?: string, options = { isAsync: false, target: 'body' }) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    const isAsync = options.isAsync;
    const target = options.target || 'body';

    script.async = isAsync;
    if (text) {
      // 脚本加载完成触发
      window.scriptLoadingSuccess = () => resolve(true);
      script.text = text;
    } else {
      script.src = src;
    }

    script.onload = () => {
      // 执行外部 JavaScript 文件中的代码
      resolve(true);
    };

    // 根据 target 参数决定将脚本添加到 head 还是 body
    const parentElement = target === 'head' ? document.head : document.body;
    parentElement.appendChild(script);
  });
}

/*
 * 用户名加密
 * @param user
 */
export const encryptUsername = (user: string) => {
  const suffix = '***';
  if (user.length <= 4) {
    return `${user}${suffix}`;
  }
  return `${user.slice(0, 5)}${suffix}`;
};

interface User {
  sort: number;
  status: number;
  type: string;
}

interface CountryData {
  [key: string]: User[];
}

interface ResultObjectWithStatus {
  code: string;
  status: number;
}

export const filterUserDataByType = (data: CountryData, targetType: string): ResultObjectWithStatus[] => {
  const result: ResultObjectWithStatus[] = [];
  for (const code in data) {
    if (data.hasOwnProperty(code)) {
      const userData = data[code];
      const matchingUser = userData.find(user => user.type === targetType);

      if (matchingUser) {
        result.push({ code, status: matchingUser.status });
      }
    }
  }

  return result;
};

export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

export const checkDeviceType = () => {
  var userAgent = navigator.userAgent;
  if (userAgent.match(/iPhone|iPad|iPod/i)) {
    return 'ios';
  } else if (userAgent.match(/Android/i)) {
    return 'Android';
  } else {
    return 'PC';
  }
};

export const hideString = str => {
  const start = str.slice(0, 6);
  const end = str.slice(str.length - 4, str.length);
  return start + '...' + end;
};

// 判断是否输入了表情
export const isEmoji = str => {
  let reg = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  return reg.test(str);
};

export const hasUrlParams = url => {
  return url.indexOf('?') > 0 && url.indexOf('=') > 0 && url.indexOf('?') < url.indexOf('=');
};

export const convertWinCodeSum = winCode => {
  let all = 0;
  if (winCode && winCode.length !== 0) {
    for (let i = 0; i < winCode.length; i += 2) {
      let sstr = winCode.substring(i, i + 2);
      all += Number(sstr);
    }
  }
  return strPadLeft(all, 2);
};

export const countDownStr = duraction => {
  let duraction2 = duraction;
  if (duraction2 <= 0) {
    duraction2 = 0;
  }
  let dd = parseInt(String(duraction2 / 1000 / 60 / 60 / 24), 10); // 计算剩余的天数
  let hh = parseInt(String((duraction2 / 1000 / 60 / 60) % 24), 10); // 计算剩余的小时数
  let mm = parseInt(String((duraction2 / 1000 / 60) % 60), 10); // 计算剩余的分钟数
  let ss = parseInt(String((duraction2 / 1000) % 60), 10); // 计算剩余的秒数
  let strdd = strPadLeft(dd, 2);
  let strhh = strPadLeft(hh, 2);
  let strmm = strPadLeft(mm, 2);
  let strss = strPadLeft(ss, 2);

  let str = '';
  if (dd > 0) {
    str += strdd + '天';
  }
  if (hh > 0) {
    str += strhh + '时';
  }
  str += strmm + '分';
  str += strss + '秒';
  return str;
};

// 判断是否为数字
export const checkRate = value => {
  let re = /^[0-9]+(.[0-9]{0,3})?$/;
  return re.test(value);
};

export const isPhoneNumber = input => {
  const phonePattern = /^\d{6,}$/;

  return phonePattern.test(input);
};

// 创建网站图标
export const creatWebIco = (href: string) => {
  if (!href) return;
  const icoLink = document.getElementById('webIcoLink');
  if (icoLink) {
    icoLink.setAttribute('href', href);
  } else {
    const link = document.createElement('link');
    link.id = 'webIcoLink';
    link.type = 'image/png'; // image/svg+xml  image/x-icon
    link.rel = 'icon';
    link.href = `${href}?v=${Date.now()}`;
    document.getElementsByTagName('head')[0].appendChild(link);
  }
};
